import { Button, Modal, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    width: "40%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `20%`,
    left: `35%`,
    //height: "40%",
    overflow: "scroll",
    textAlign: "center",
  },
  textField: {
    width: "100%",
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 15,
  },
  subtitle: {
    float: "left",
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 5,
  },
  saveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.red.hover,
    },
    color: theme.palette.gif.red.color,
    backgroundColor: theme.palette.gif.red.background,
    margin: 5,
  },
  button: {
    margin: 5,
  },
}));

export default function DeclinePreProposalModal(props) {
  const { open, onClose, decline } = props;
  const classes = useStyles();
  const [declineReason, setDeclineReason] = useState("");
  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.root}>
        <Typography className={classes.title}>Decline Pre Proposal</Typography>
        <Typography className={classes.subtitle}>
          Please enter reason for decline:
        </Typography>
        <TextField
          label="Decline Reason"
          value={declineReason}
          multiline
          rows={6}
          maxRows={15}
          size="small"
          onChange={(e) => setDeclineReason(e.target.value)}
          className={classes.textField}
        />
        <Box marginTop={1} style={{ float: "right" }} marginBottom={-2}>
          <Button
            disableElevation
            variant="contained"
            className={classes.button}
            onClick={onClose}
          >
            Cancel
          </Button>
            <Button
              disableElevation
              variant="contained"
              className={classes.saveButton}
              disabled={declineReason === ""}
              onClick={() => {
                decline(declineReason);
                onClose();
              }}
            >
              Decline
            </Button>
            {declineReason === ""&&<Typography style={{color:"red" ,fontSize:14}}>*Must entered decline reason</Typography>}
        </Box>
      </Box>
    </Modal>
  );
}
